import { Model } from "./Concers/Model";

export class Setting extends Model {
    id: number;
    title: string;
    enabled: boolean;

    public translatable = ["title"];

    constructor(item) {
        super(item);
    }
}
